.component {
  margin: 23px var(--margin) 20px 20px;
  overflow: auto;
  height: 100%;
}

.title {
  margin-bottom: 10px;
  font-size: 26px;
  font-weight: 300;
  color: var(--tealish);
}

.subTitle {
  width: 550px;
  font-size: 14px;
  color: var(--marine);
}

.section {
  margin-top: 20px;
  padding-left: 5px;
}

.underline {
  margin: 15px 0;
  width: 542px;
  border-bottom: dotted 3px var(--pinkish-grey);
}

.provider {
  width: 542px;
}

.providerHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.providerName {
  font-size: 18px;
  font-weight: 500;
  color: var(--marine);
}

.comingSoon {
  font-size: 13px;
  color: var(--brown-grey);
}

.connectButton {
  background-color: var(--marine);
  height: 33px;
  border: none;
  border-radius: 4px;
  padding: 0 20px;
  font-size: 13px;
  color: var(--fully-white);
  cursor: pointer;
}

.connectedRow {
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.connectedLabel {
  flex: 1;
  color: var(--marine);
}

.trash {
  width: 11.4px;
  height: 12.3px;
  padding: 10px;
  object-fit: contain;
  cursor: pointer;
}

.repoRow {
  min-height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
  margin: 3px 3px 3px 0;
  padding: 0 10px;
  background-color: var(--fully-white);
}

.appName {
  flex: 1;
  color: var(--marine);
}
